/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiEmployeesIdCvUploadMutationRequest,
  PostApiEmployeesIdCvUploadMutationResponse,
  PostApiEmployeesIdCvUploadPathParams,
} from '../models/PostApiEmployeesIdCvUpload.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiEmployeesIdCvUploadMutationResponseSchema,
  postApiEmployeesIdCvUploadMutationRequestSchema,
} from '../zod/postApiEmployeesIdCvUploadSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiEmployeesIdCvUploadMutationKey = () =>
  [{ url: '/api/employees/:id/cv/upload' }] as const;

export type PostApiEmployeesIdCvUploadMutationKey = ReturnType<
  typeof postApiEmployeesIdCvUploadMutationKey
>;

/**
 * {@link /api/employees/:id/cv/upload}
 */
export async function postApiEmployeesIdCvUpload(
  id: PostApiEmployeesIdCvUploadPathParams['id'],
  data: PostApiEmployeesIdCvUploadMutationRequest,
  config: Partial<RequestConfig<PostApiEmployeesIdCvUploadMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData =
    postApiEmployeesIdCvUploadMutationRequestSchema.parse(data);
  const formData = new FormData();
  if (requestData) {
    Object.keys(requestData).forEach((key) => {
      const value = requestData[key as keyof typeof requestData];
      if (typeof value === 'string' || (value as unknown) instanceof Blob) {
        formData.append(key, value as unknown as string | Blob);
      }
    });
  }
  const res = await request<
    PostApiEmployeesIdCvUploadMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiEmployeesIdCvUploadMutationRequest
  >({
    method: 'POST',
    url: `/api/employees/${id}/cv/upload`,
    data: formData,
    ...requestConfig,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...requestConfig.headers,
    },
  });
  return postApiEmployeesIdCvUploadMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/employees/:id/cv/upload}
 */
export function usePostApiEmployeesIdCvUpload<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiEmployeesIdCvUploadMutationResponse,
      ResponseErrorConfig<Error>,
      {
        id: PostApiEmployeesIdCvUploadPathParams['id'];
        data: PostApiEmployeesIdCvUploadMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiEmployeesIdCvUploadMutationRequest>
    > & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiEmployeesIdCvUploadMutationKey();

  return useMutation<
    PostApiEmployeesIdCvUploadMutationResponse,
    ResponseErrorConfig<Error>,
    {
      id: PostApiEmployeesIdCvUploadPathParams['id'];
      data: PostApiEmployeesIdCvUploadMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return postApiEmployeesIdCvUpload(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
